import clsx from 'clsx';
import type * as React from 'react';

import { getEmojiForCode, getEmojiLabelForCode, isEmojiCode } from '@gitbook/util-emoji-rendering';

// ❓
const notFoundEmojiCode = '2753';

export interface EmojiProps {
    code: string;
    /**
     * Size in pixels. If null, will use font size of the parent element.
     */
    size?: number | string | null;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Render a single emoji from an UTF code.
 */
export function Emoji(props: EmojiProps): React.ReactElement {
    const { size, className, style } = props;

    const code = isEmojiCode(props.code) ? props.code : notFoundEmojiCode;
    const character = getEmojiForCode(code);
    const emojiLabel = getEmojiLabelForCode(code) ?? 'Emoji';
    const resolvedSize = typeof size === 'number' ? `${size / 16}rem` : size;

    return (
        <span
            className={clsx('font-emoji', className)}
            role="img"
            aria-label={emojiLabel}
            style={
                resolvedSize
                    ? {
                          fontSize: resolvedSize,
                          lineHeight: resolvedSize,
                          // Emoji glyphs are not vertically centered in their line box,
                          // so we offset them by 1px to appear visually centered
                          transform: 'translateY(0.0625rem)',
                          ...style,
                      }
                    : style
            }
        >
            {character}
        </span>
    );
}
